const configuredMicrosoftAuthTenant = (
  typeof __MICROSOFT_AUTH_TENANT__ === 'undefined'
    ? ''
    : __MICROSOFT_AUTH_TENANT__
);

export function getMicrosoftAuthTenant() {
  return String(configuredMicrosoftAuthTenant || '').trim();
}
